import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisProjectSettingsPoliciesRoute: InvariantJiraRoute = {
	name: 'polaris-project-settings-policies',
	path: '/jira/polaris/projects/:projectKey/ideas/settings/policies',
	exact: true,
};
